import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';

const DentalCriteria3 = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    browsingFilterStore: { getFilterValueCheckboxValue, onValueCheckboxFilterChange },
  } = useRootStore();

  const filterName = 'Annual Maximum Benefit';

  // Values for radio buttons group
  const radioButtons = [
    {
      id: 'annual-2000',
      label: '$2,000 annual benefit maximum',
      value: '2000',
    },
    {
      id: 'annual-1500',
      label: '$1,500 annual benefit maximum',
      value: '1500',
    },
    {
      id: 'annual-1000',
      label: '$1,000 annual benefit maximum',
      value: '1000',
    },
    {
      id: 'all',
      label: 'Show me all options',
      value: 'all',
    },
  ];

  return (
    <div>
      <TextBlock
        title="Choose Your Annual Benefit"
        subtitle="The annual benefit maximum is the total amount of expenses that your plan will cover in a calendar year. For example, a plan with a $1,000 benefit amount will only cover up to $1,000 of expenses for covered services. Expenses beyond the annual benefit maximum are paid by the member at the discounted network rate."
      />
      <RadioGroup
        label=""
        value={getFilterValueCheckboxValue(filterName)}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onValueCheckboxFilterChange(filterName, e.target.value);
        }}
      />
    </div>
  );
});

export default withCriteria(DentalCriteria3, 3);
